<section class="create-project-section">
    <div class="container">

        <div class="card">

            <div class="header-row">

                <!-- Back Button (always visible) -->
                <button class="icon-btn back" routerLink="/projects">
                    <i class="fa-solid fa-arrow-left"></i>
                </button>

                <!-- Page Title -->
                <h3 class="page-title">
                    {{ mode === 'create' ? 'Create Project' : mode === 'edit' ? 'Edit Project' : 'Project Details' }}
                </h3>

                <!-- Spacer to push edit/delete to the far right -->
                <div class="flex-spacer"></div>

                <!-- Edit/Delete only in VIEW mode -->
                <div class="header-actions" *ngIf="mode === 'view'">
                    <button class="icon-btn edit" (click)="goToEdit()">
                        <i class="fa-solid fa-pen-to-square"></i>
                    </button>

                    <button class="icon-btn delete" (click)="deleteProject()">
                        <i class="fa-solid fa-trash"></i>
                    </button>
                </div>

                <div class="header-actions" *ngIf="mode === 'edit'">
                    <button class="icon-btn view" (click)="viewProject()">
                        <i class="fa-solid fa-eye"></i>
                    </button>


                    <button class="icon-btn delete" (click)="deleteProject()">
                        <i class="fa-solid fa-trash"></i>
                    </button>
                </div>

            </div>

            <div *ngIf="mode !== 'create'" class="microservices-section">

                <h4>Microservices</h4>

                <div *ngIf="loadingMicroservices">Loading...</div>

                <!-- EDIT MODE: show toggles -->
                <ng-container *ngIf="mode === 'edit'">
                    <div class="microservice-item" *ngFor="let ms of allMicroservices">

                        <span class="microservice-name">
                            {{ ms.serviceName }}
                        </span>

                        <label class="switch">
                            <input type="checkbox" [checked]="ms.enabled" (change)="onMicroserviceToggle(ms, $event)" />
                            <span class="slider"></span>
                        </label>

                    </div>
                </ng-container>

                <!-- VIEW MODE: text only, no toggle -->
                <ng-container *ngIf="mode === 'view'">
                    <div class="microservice-item readonly" *ngFor="let ms of allMicroservices">

                        <span class="microservice-name">
                            {{ ms.serviceName }}
                        </span>

                    </div>
                </ng-container>

            </div>



            <div class="form-wrapper">

                <!-- Domain -->
                <label>Domain</label>
                <input [(ngModel)]="domain" placeholder="example.com">

                <!-- Description -->
                <label>Description</label>
                <textarea [(ngModel)]="description" rows="3"></textarea>

                <!-- Supported Languages -->
                <label>Supported Languages</label>
                <input [(ngModel)]="supportedLanguages" placeholder="en,ar,de" [disabled]="mode === 'view'">

                <small class="hint">
                    Comma-separated ISO codes (e.g. en, ar, de)
                </small>


                <label>Status</label>
                <div class="toggle-container">
                    <label class="switch">
                        <input type="checkbox" [(ngModel)]="active" (change)="onStatusToggle()" />
                        <span class="slider"></span>
                    </label>

                    <span class="toggle-label">
                        {{ active ? "Active" : "Inactive" }}
                    </span>
                </div>

                <!-- Project ID -->
                <div *ngIf="mode === 'view'">
                    <label>Project ID</label>
                    <input [(ngModel)]="projectId">
                </div>

                <!-- CREATION DATE -->
                <label>Creation Date</label>
                <input type="text" [value]="creationDate | date:'yyyy-MM-dd HH:mm'" disabled>

                <!-- ENV JSON EDITOR -->
                <app-project-env-editor [(envJson)]="envVariablesJson"></app-project-env-editor>

                <!-- Action Buttons -->
                <div class="actions" style="margin-top: 20px">
                    <button *ngIf="mode === 'create'" class="btn-primary" (click)="createProject()">
                        + Create Project
                    </button>

                    <button *ngIf="mode === 'edit'" class="btn-primary" (click)="saveChanges()">
                        💾 Save Changes
                    </button>
                </div>

            </div>

        </div>

    </div>
</section>